<template>
  <el-dialog
    class="commitment-config-modal"
    top="10vh"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="onResetForm"
    :title="(isNewCommitment ? 'Create new commitment' : 'Commitment Settings')">

    <template v-if="( isNewCommitment || commitmentId ) && goalId">
      <CommitmentWizard
        v-if="showWizard"
        :is-new-commitment="isNewCommitment"
        :new-type="type"
        :goal-id="goalId"
        :commitment-id="commitmentId"
        :member-id="memberId"
        @done="onGoalConfigDone"
      />
      <CommitmentConfig
        v-else
        :is-new-commitment="isNewCommitment"
        :goal-id="goalId"
        :new-type="type"
        :commitment-id="commitmentId"
        :member-id="memberId"
        :tsc-id="tscId"
        @done="onGoalConfigDone"
      />
    </template>
  </el-dialog>
</template>

<script>
import CommitmentConfig from '@/components/Config/CommitmentConfig'
import CommitmentWizard from '@/components/Config/CommitmentWizard'

function getDefaultData() {
  return {
    dialogVisible:      false,
    isNewCommitment:    false,
    showWizard:         false,
    goalId:             null,
    memberId:           null,
    commitmentId:       null,
    tscId:              null,
    type:               null
  }
}

export default {
  data: () => {
    return getDefaultData()
  },
  methods: {
    showNewModal({ goalId, type, tscId = null, showWizard = false }) {
      console.log("showNewEffortForm", goalId, type, tscId, showWizard);

      if ( ![ 'TASKLIST', 'BACKLOG', 'SEQUENCE', 'MAGICLIST', 'TRELLO', 'HABIT', 'AMOUNT', 'TIME_BASED_TASKLIST', null ].includes( type ) ) {
        throw new Error('Invalid type: ' + type)
      }

      this.isNewCommitment   = true;
      this.goalId            = goalId; // MAKE PROP
      this.type              = type;   // MAKE PROP
      this.memberId          = null;
      this.commitmentId      = null;   // MAKE PROP
      this.tscId             = tscId;
      this.dialogVisible     = true;
      this.showWizard        = showWizard;
    },

    showUpdateModal({ goalId, commitmentId, memberId, showWizard = false }) {
      console.log("showUpdateModal", goalId, commitmentId);

      this.isNewCommitment   = false;
      this.goalId            = goalId;
      /* set to current user if not provided */
      this.memberId          = memberId || this.$models.user.defaultUserId; // Check: Backlog?
      this.commitmentId      = commitmentId;
      this.dialogVisible     = true;
      this.showWizard        = showWizard;
    },

    onResetForm() {
      console.log("onResetForm");
      Object.assign(this.$data, getDefaultData())
    },

    onGoalConfigDone() {
      this.onResetForm();
    }
  },
  components: {
    CommitmentConfig,
    CommitmentWizard,
  }
}
</script>

<style>
.commitment-config-modal .el-dialog {
  /*min-width: 600px;*/
/*  max-width: 800px;*/
}
</style>
